import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  innerWrapper: ({ level }) => ({
    paddingLeft: theme.spacing(2 * level),
  }),
  downloadText: {
    cursor: 'pointer',
  },
  selectWrapper: {
    '& label.MuiInputLabel-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 24px)',
    },
  },
}));

export default useStyles;
